// @flow

import pdb from './pdb';
import routes from './routes';
import blog from './blog';
import blogSettings from './blogSettings';
import compareSettings from './compareSettings';
import componentSettings from './componentSettings';
import configuratorSettings from './configuratorSettings';
import contactSettings from './contactSettings';
import footerSettings from './footerSettings';
import formidableSettings from './formidableSettings';
import formSettings from './formSettings';
import menus from './menus';
import news from './news';
import newsSettings from './newsSettings';
import siteSettings from './siteSettings';
import socialSettings from './socialSettings';
import wpSettings from './wpSettings';
import openingHours from './openinghours';
import uiSettings from './uiStore';
import settings from './settings';
import configuration from './configuration';
import activeLanguage from './activeLanguage';
import pdbComparison from './pdbComparison';
import assortment from './assortment';
import assortmentSettings from './assortmentSettings';
import businessLabelSettings from './businessLabelSettings';
import productTypeSettings from './productTypeSettings';
import gtm from './gtm';
import orderForm from './orderForm';
import vbmr from './vbmr';
import review from './review';

export type { State } from './types';

export default {
  activeLanguage,
  assortment,
  assortmentSettings,
  blog,
  blogSettings,
  businessLabelSettings,
  compareSettings,
  componentSettings,
  configuration,
  configuratorSettings,
  contactSettings,
  footerSettings,
  formidableSettings,
  formSettings,
  gtm,
  menus,
  news,
  newsSettings,
  openingHours,
  orderForm,
  pdb,
  pdbComparison,
  productTypeSettings,
  review,
  routes,
  settings,
  siteSettings,
  socialSettings,
  uiSettings,
  vbmr,
  wpSettings,
};
